import { Component, OnInit, HostListener } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ApiServiceService } from '../../services/common/api-service.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-signup-personal',
  templateUrl: './signup-personal.component.html',
  styleUrls: ['./signup-personal.component.scss'],
})
export class SignupPersonalComponent implements OnInit {
  @HostListener('document:click', ['$event'])
  clickOutside(event: MouseEvent) {

    const target = event.target as HTMLElement;

    if (!target.closest('.custom-dropdown')) {

      this.showHeightList = false;
      this.showWeightList = false;
      this.showMaritalList = false;
      this.showPhysicalList = false;
      this.showFoodList = false;
      this.showSmokingList = false;
      this.showDrinkingList = false;
      this.showBodyList = false;

    }

  }
  signuppersonal!: FormGroup;
  heightValues: number[] = [];
  weightValues: number[] = [];
  // citizenships: any[] = [];
  imagePreview: string | ArrayBuffer | null = null;
  selectedHeight = '';
  selectedWeight = '';
  selectedMarital = '';
  selectedPhysical = '';
  selectedFood = '';
  selectedSmoking = '';
  selectedDrinking = '';
  selectedBody = '';

  heightList: any[] = [];
  weightList: any[] = [];

  filteredHeightList: any[] = [];
  filteredWeightList: any[] = [];

  maritalList = ['Never Married', 'Widowed', 'Divorced'];

  filteredMaritalList = [...this.maritalList];

  physicalList = ['Normal', 'Physically Challenged'];

  filteredPhysicalList = [...this.physicalList];

  foodList = ['Vegetarian', 'Non-Vegetarian', 'Eggetarian'];

  filteredFoodList = [...this.foodList];

  smokingList = ['No', 'Yes', 'Occasionally'];
  filteredSmokingList = [...this.smokingList];

  drinkingList = ['No', 'Yes', 'Occasionally'];
  filteredDrinkingList = [...this.drinkingList];

  bodyList = ['Slim', 'Average', 'Athletic', 'Heavy'];
  filteredBodyList = [...this.bodyList];

  showHeightList = false;
  showWeightList = false;
  showMaritalList = false;
  showPhysicalList = false;
  showFoodList = false;
  showSmokingList = false;
  showDrinkingList = false;
  showBodyList = false;

  constructor(
    private apiService: ApiServiceService,
    private formBuilder: FormBuilder,
    private router: Router,
  ) {
    this.signuppersonal = this.formBuilder.group({
      height: ['', Validators.required],
      weight: ['', Validators.required],
      physical: ['', Validators.required],
      food: ['', Validators.required],
      smoking: [''],
      drinking: [''],
      body: [''],
      marital: ['', Validators.required],
      // citizenship: ['', Validators.required],
      avatar: [null, Validators.required]
    });
    this.heightValues = this.generateHeightValues();
    this.weightValues = this.generateWeightValues();
    this.heightList = this.heightValues.map((x) => x + ' cm');
    this.weightList = this.weightValues.map((x) => x + ' kg');

    this.filteredHeightList = this.heightList;
    this.filteredWeightList = this.weightList;
  }

  ngOnInit(): void {
    const profileId = localStorage.getItem('profileId');
    const sessionToken = localStorage.getItem('sessionToken');
    if (!profileId || !sessionToken) {
      this.router.navigate(['/signup-basic']);
      return;
    }

    // this.apiService.getCitizenship().subscribe({
    //   next: (response: any) => {
    //     if (response.status === 'success') {
    //       this.citizenships = response.data;
    //     }
    //   },
    //   error: (err) => console.error('Error fetching citizenship:', err)
    // });
  }

  openDropdown(type: string) {
    this.showHeightList = false;
    this.showWeightList = false;
    this.showMaritalList = false;
    this.showPhysicalList = false;
    this.showFoodList = false;
    this.showSmokingList = false;
    this.showDrinkingList = false;
    this.showBodyList = false;
    if (type === 'height') {
      this.filteredHeightList = this.heightList;
      this.showHeightList = true;
    }

    if (type === 'weight') {
      this.filteredWeightList = this.weightList;
      this.showWeightList = true;
    }

    if (type === 'marital') {
      this.filteredMaritalList = this.maritalList;
      this.showMaritalList = true;
    }

    if (type === 'physical') {
      this.filteredPhysicalList = this.physicalList;
      this.showPhysicalList = true;
    }

    if (type === 'food') {
      this.filteredFoodList = this.foodList;
      this.showFoodList = true;
    }

    if (type === 'smoking') {
      this.filteredSmokingList = this.smokingList;
      this.showSmokingList = true;
    }

    if (type === 'drinking') {
      this.filteredDrinkingList = this.drinkingList;
      this.showDrinkingList = true;
    }

    if (type === 'body') {
      this.filteredBodyList = this.bodyList;
      this.showBodyList = true;
    }
  }

  searchDropdown(event: any, type: string) {
    const value = event.target.value.toLowerCase();

    if (type === 'height') {
      this.filteredHeightList = this.heightList.filter((x) =>
        x.toLowerCase().includes(value),
      );
    }

    if (type === 'weight') {
      this.filteredWeightList = this.weightList.filter((x) =>
        x.toLowerCase().includes(value),
      );
    }

    if (type === 'marital') {
      this.filteredMaritalList = this.maritalList.filter((x) =>
        x.toLowerCase().includes(value),
      );
    }

    if (type === 'physical') {
      this.filteredPhysicalList = this.physicalList.filter((x) =>
        x.toLowerCase().includes(value),
      );
    }

    if (type === 'food') {
      this.filteredFoodList = this.foodList.filter((x) =>
        x.toLowerCase().includes(value),
      );
    }

    if (type === 'smoking') {
      this.filteredSmokingList = this.smokingList.filter((x) =>
        x.toLowerCase().includes(value),
      );
    }

    if (type === 'drinking') {
      this.filteredDrinkingList = this.drinkingList.filter((x) =>
        x.toLowerCase().includes(value),
      );
    }

    if (type === 'body') {
      this.filteredBodyList = this.bodyList.filter((x) =>
        x.toLowerCase().includes(value),
      );
    }
  }

  selectDropdown(value: string, type: string) {
    if (type === 'height') {
      this.selectedHeight = value;
      this.signuppersonal.patchValue({
        height: value.replace(' cm', ''),
      });
      this.showHeightList = false;
    }

    if (type === 'weight') {
      this.selectedWeight = value;
      this.signuppersonal.patchValue({
        weight: value.replace(' kg', ''),
      });
      this.showWeightList = false;
    }

    if (type === 'marital') {
      this.selectedMarital = value;
      this.signuppersonal.patchValue({
        marital: value,
      });
      this.showMaritalList = false;
    }

    if (type === 'physical') {
      this.selectedPhysical = value;
      this.signuppersonal.patchValue({
        physical: value,
      });
      this.showPhysicalList = false;
    }

    if (type === 'food') {
      this.selectedFood = value;
      this.signuppersonal.patchValue({
        food: value,
      });
      this.showFoodList = false;
    }

    if (type === 'smoking') {
      this.selectedSmoking = value;
      this.signuppersonal.patchValue({
        smoking: value,
      });
      this.showSmokingList = false;
    }

    if (type === 'drinking') {
      this.selectedDrinking = value;
      this.signuppersonal.patchValue({
        drinking: value,
      });
      this.showDrinkingList = false;
    }

    if (type === 'body') {
      this.selectedBody = value;
      this.signuppersonal.patchValue({
        body: value,
      });
      this.showBodyList = false;
    }
  }

  generateHeightValues(): number[] {
    const heights: number[] = [];
    for (let i = 60; i <= 250; i++) {
      heights.push(i);
    }
    return heights;
  }

  generateWeightValues(): number[] {
    const weights: number[] = [];
    for (let i = 40; i <= 150; i++) {
      weights.push(i);
    }
    return weights;
  }

  onFileChange(event: any) {
    const file = (event.target as HTMLInputElement).files?.[0];
    if (file) {
      this.signuppersonal.patchValue({ avatar: file });
      this.signuppersonal.get('avatar')?.updateValueAndValidity();

      // Show preview
      const reader = new FileReader();
      reader.onload = () => {
        this.imagePreview = reader.result;
      };
      reader.readAsDataURL(file);
    }
  }

  onSubmit() {
    if (this.signuppersonal.valid) {
      const profileId = localStorage.getItem('profileId');
      const sessionToken = localStorage.getItem('sessionToken');

      if (!profileId || !sessionToken) {
        Swal.fire('Error', 'Session expired. Please sign up again.', 'error');
        this.router.navigate(['/signup-basic']);
        return;
      }

      const formData = new FormData();
      formData.append('action', 'personal');
      formData.append('type', 'signup');
      formData.append('profileId', profileId);

      const avatarFile = this.signuppersonal.get('avatar')?.value;
      if (avatarFile instanceof File) {
        formData.append('avatar', avatarFile, avatarFile.name);
      }

      const data: any = {
        personal_info: {
          marital_status: this.signuppersonal.get('marital')!.value,
          height: this.signuppersonal.get('height')!.value,
          weight: this.signuppersonal.get('weight')!.value,
          physical_status: this.signuppersonal.get('physical')!.value,
          food: this.signuppersonal.get('food')!.value,
          smoking: this.signuppersonal.get('smoking')?.value || undefined,
          drinking: this.signuppersonal.get('drinking')?.value || undefined,
          body_type: this.signuppersonal.get('body')?.value || undefined,
        }
      };
      formData.append('data', JSON.stringify(data));

      this.apiService.submitPersonalData(formData, sessionToken).subscribe({
        next: (response) => {
          if (response.status === 'success') {
            this.router.navigate(['/signup-professional']);
          } else {
            Swal.fire({
              title: 'Error',
              text: response.message || 'Failed to submit personal details.',
              icon: 'error',
              confirmButtonColor: '#a73453',
            });
          }
        },
        error: (error) => {
          console.error('Submit personal details error:', error);
          Swal.fire({
            title: 'Error',
            text: 'An error occurred. Please try again.',
            icon: 'error',
            confirmButtonColor: '#a73453',
          });
        },
      });
    } else {
      this.signuppersonal.markAllAsTouched();
      Swal.fire({
        title: 'Form Invalid',
        text: 'Please select all personal details and upload a photo.',
        icon: 'warning',
        confirmButtonColor: '#a73453',
      });
    }
  }
}
